// src/services/auth.js - FIXED VERSION
import { apiClient } from './api';
import { API_ENDPOINTS } from '../utils/constants';

export const authService = {
  // User registration
  register: async (userData) => {
    try {
      console.log('Auth register called with:', userData);
      const result = await apiClient.post(API_ENDPOINTS.AUTH.REGISTER, userData);
      
      if (result.success) {
        return {
          success: true,
          data: result.data,
          message: result.data.message || 'Registration successful'
        };
      } else {
        return {
          success: false,
          message: result.error.message || 'Registration failed',
          error: result.error
        };
      }
    } catch (error) {
      console.error('Register error:', error);
      return {
        success: false,
        message: 'Registration failed',
        error: error
      };
    }
  },

  // User login
  login: async (credentials) => {
    try {
      console.log('Auth login called with:', { email: credentials.email });
      const result = await apiClient.post(API_ENDPOINTS.AUTH.LOGIN, credentials);
      
      if (result.success) {
        return {
          success: true,
          data: result.data,
          message: result.data.message || 'Login successful'
        };
      } else {
        return {
          success: false,
          message: result.error.message || 'Login failed',
          error: result.error
        };
      }
    } catch (error) {
      console.error('Login error:', error);
      return {
        success: false,
        message: 'Login failed',
        error: error
      };
    }
  },

  // User logout
  logout: async () => {
    try {
      console.log('Auth logout called');
      const result = await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT);
      
      if (result.success) {
        return {
          success: true,
          data: result.data,
          message: result.data.message || 'Logout successful'
        };
      } else {
        return {
          success: false,
          message: result.error.message || 'Logout failed',
          error: result.error
        };
      }
    } catch (error) {
      console.error('Logout error:', error);
      return {
        success: false,
        message: 'Logout failed',
        error: error
      };
    }
  },

  // Get current user
  getCurrentUser: async () => {
    try {
      console.log('Auth getCurrentUser called');
      const result = await apiClient.get(API_ENDPOINTS.AUTH.ME);
      
      if (result.success) {
        return {
          success: true,
          data: result.data.user || result.data,
          message: result.data.message || 'User data retrieved'
        };
      } else {
        return {
          success: false,
          message: result.error.message || 'Failed to get user data',
          error: result.error
        };
      }
    } catch (error) {
      console.error('Get current user error:', error);
      return {
        success: false,
        message: 'Failed to get user data',
        error: error
      };
    }
  },

  // Update user profile
  updateProfile: async (profileData) => {
    try {
      console.log('Auth updateProfile called with:', profileData);
      const result = await apiClient.put(API_ENDPOINTS.AUTH.PROFILE, profileData);
      
      if (result.success) {
        return {
          success: true,
          data: result.data.user || result.data,
          message: result.data.message || 'Profile updated successfully'
        };
      } else {
        return {
          success: false,
          message: result.error.message || 'Profile update failed',
          error: result.error
        };
      }
    } catch (error) {
      console.error('Update profile error:', error);
      return {
        success: false,
        message: 'Profile update failed',
        error: error
      };
    }
  },

  // Change password
  changePassword: async (passwordData) => {
    try {
      console.log('Auth changePassword called');
      const result = await apiClient.put(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, passwordData);
      
      if (result.success) {
        return {
          success: true,
          data: result.data,
          message: result.data.message || 'Password changed successfully'
        };
      } else {
        return {
          success: false,
          message: result.error.message || 'Password change failed',
          error: result.error
        };
      }
    } catch (error) {
      console.error('Change password error:', error);
      return {
        success: false,
        message: 'Password change failed',
        error: error
      };
    }
  },

  // Verify token
  verifyToken: async () => {
    try {
      console.log('Auth verifyToken called');
      const result = await apiClient.get(API_ENDPOINTS.AUTH.VERIFY);
      
      if (result.success) {
        return {
          success: true,
          data: result.data,
          message: result.data.message || 'Token verified'
        };
      } else {
        return {
          success: false,
          message: result.error.message || 'Token verification failed',
          error: result.error
        };
      }
    } catch (error) {
      console.error('Verify token error:', error);
      return {
        success: false,
        message: 'Token verification failed',
        error: error
      };
    }
  },

  // Refresh token
  refreshToken: async () => {
    try {
      console.log('Auth refreshToken called');
      const result = await apiClient.post(API_ENDPOINTS.AUTH.REFRESH);
      
      if (result.success) {
        return {
          success: true,
          data: result.data,
          message: result.data.message || 'Token refreshed'
        };
      } else {
        return {
          success: false,
          message: result.error.message || 'Token refresh failed',
          error: result.error
        };
      }
    } catch (error) {
      console.error('Refresh token error:', error);
      return {
        success: false,
        message: 'Token refresh failed',
        error: error
      };
    }
  }
};

// Also export as authAPI for backward compatibility
export const authAPI = authService;

// Default export
export default authService;